import { render, staticRenderFns } from "./GetTeachingMaterialTree.vue?vue&type=template&id=606531aa&scoped=true"
import script from "./GetTeachingMaterialTree.vue?vue&type=script&lang=js"
export * from "./GetTeachingMaterialTree.vue?vue&type=script&lang=js"
import style0 from "./GetTeachingMaterialTree.vue?vue&type=style&index=0&id=606531aa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606531aa",
  null
  
)

export default component.exports